import React from 'react'
import { getProductDraft } from '../../../../actions/product/DraftActions'
import { connect } from 'react-redux'
import { addDescriptionItemWithNotification } from '../../../../actions/DescriptionActions'
import { TEXT, TABLE } from '../../../../consts'
import {
    Button,
    withStyles,
    Table,
    TableBody,
    TableRow,
    TableCell,
} from '@material-ui/core'
import { Typography } from '@material-ui/core'
import classNames from 'classnames'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { generateProductDescription } from '../../../../actions/AIActions'
import Input from '../../../../components/Input'

const styles = theme => ({
    item: {
        paddingLeft: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        fontSize: '6px',
        lineHeight: `${6 * 1.375}px`,
        //marginBottom: 4 * theme.spacing.unit,
    },

    itemText: {
        fontSize: '2em',
        lineHeight: '1.375em',
        fontFamily: '"Open Sans", Muli, Roboto, Arial, sans-serif',
    },

    itemHeader: {
        fontSize: '3em',
        lineHeight: '1em',
        marginTop: `${2 / 3}em`,
        marginBottom: `${2 / 3}em`,
        fontFamily: '"Open Sans", Muli, Roboto, Arial, sans-serif',
    },

    button: {
        marginTop: 2 * theme.spacing.unit,
        marginRight: 2 * theme.spacing.unit,
    },

    hr: {
        marginTop: 4 * theme.spacing.unit,
        marginBottom: 4 * theme.spacing.unit,
        height: '1px',
        backgroundColor: 'grey',
    },

    h: {
        marginBottom: theme.spacing.unit * 2,
    },
})

const hasOwnProperty = Object.prototype.hasOwnProperty

const ItemText = props => {
    const { classes, text } = props

    return (
        <span
            className={classes.itemText}
            dangerouslySetInnerHTML={{ __html: text }}
        />
    )
}

const ItemTable = props => {
    const { data } = props

    let json = null

    try {
        if (hasOwnProperty.call(data, 'data')) {
            console.log('hasOwnProperty', data)
            json = data.data
        } else {
            json = JSON.parse(data)

            if (hasOwnProperty.call(json, 'data')) {
                json = json.data
            }
        }
    } catch (e) {
        console.error(e)
    }

    if (json === null) {
        return null
    }

    return (
        <Table>
            <TableBody>
                {json.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                        {row.map((value, colIndex) => {
                            const isBolded = colIndex === 0
                            const key = `${rowIndex}-${colIndex}`

                            if (isBolded) {
                                return (
                                    <TableCell key={key}>
                                        <b>{value}</b>
                                    </TableCell>
                                )
                            }

                            return <TableCell key={key}>{value}</TableCell>
                        })}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}

const ItemHeader = props => {
    const { classes, header } = props

    return (
        <Typography className={classes.itemHeader} variant="h6">
            <span
                className="align-middle"
                dangerouslySetInnerHTML={{ __html: header }}
            />
        </Typography>
    )
}

class GenerateDescriptionModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            productName: this.props.productName,
            producerUrl: '',
            specificationUrl: '',
        }
    }

    onChangeProductName = event => {
        console.log(event.target.value)
        this.setState({ productName: event.target.value })
    }

    onChangeProducerUrl = event => {
        this.setState({ producerUrl: event.target.value })
    }

    onChangeSpecificationUrl = event => {
        this.setState({ specificationUrl: event.target.value })
    }

    generateProductDescription = sku => {
        if (
            sku === '' &&
            this.state.productName === '' &&
            this.state.producerUrl === '' &&
            this.state.specificationUrl === ''
        ) {
            return
        }

        this.props.onConfirm(
            sku,
            this.state.productName,
            this.state.producerUrl,
            this.state.specificationUrl
        )
    }

    render() {
        const { open, handleClose, sku } = this.props

        return (
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Wygeneruj opis produktu
                </DialogTitle>
                <DialogContent>
                    <Input
                        className="mt-8 mb-16 mr-8"
                        required
                        label="Nazwa produktu"
                        name="productName"
                        id="productName"
                        value={this.state.productName}
                        onChange={this.onChangeProductName}
                        variant="outlined"
                        fullWidth
                    />
                    <Input
                        className="mt-8 mb-16 mr-8"
                        required
                        label="Link do strony producenta"
                        name="producerUrl"
                        id="producerUrl"
                        value={this.state.producerUrl}
                        onChange={this.onChangeProducerUrl}
                        variant="outlined"
                        fullWidth
                    />
                    <Input
                        className="mt-8 mb-16"
                        required
                        label="Link do specyfikacji"
                        name="specificationUrl"
                        id="specificationUrl"
                        value={this.state.specificationUrl}
                        onChange={this.onChangeSpecificationUrl}
                        variant="outlined"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Anuluj
                    </Button>
                    <Button
                        onClick={() => this.generateProductDescription(sku)}
                        color="primary"
                        autoFocus
                    >
                        Potwierdź
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

class ProductDraft extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
        }
    }

    toggleOpen = () => {
        this.setState({ open: !this.state.open })
    }

    componentDidMount() {
        const { getProductDraft, sku } = this.props
        getProductDraft(sku)
    }

    addAllBlocksToDescription = () => {
        this.props.draft.description.forEach(item => {
            const descriptionItem = {
                descriptionItemTypeId: TEXT,
                staticBlockId: null,
                bundleItemId: null,
                header: item.header,
                text: item.text,
                image1: -1,
                image2: -1,
                json: {
                    cols: [],
                    data: [],
                    boldedRows: [],
                    boldedCols: [],
                    boldedCells: [],
                },
                notForAllegro: false,
                notForMagento: false,
                notForHurton: false,
                youtubeLink: '',
                hoverIndex: null,
                headerIcon: '',
                filterStaticBlocks: false,
            }

            if (item.header.startsWith('Specyfikacja techniczna')) {
                descriptionItem.text = ''
                descriptionItem.descriptionItemTypeId = TABLE
                descriptionItem.json.cols = [
                    { name: 'A', key: 0 },
                    { name: 'B', key: 1 },
                ]

                try {
                    if (hasOwnProperty.call(item.text, 'data')) {
                        const data = item.text.data
                        descriptionItem.json.data = data

                        for (let i = 0, len = data.length; i < len; i++) {
                            descriptionItem.json.boldedCells.push({
                                row: i,
                                col: 0,
                            })
                        }
                    } else {
                        let data = JSON.parse(item.text)

                        if (hasOwnProperty.call(data, 'data')) {
                            data = data.data
                        }

                        descriptionItem.json.data = data

                        for (let i = 0, len = data.length; i < len; i++) {
                            descriptionItem.json.boldedCells.push({
                                row: i,
                                col: 0,
                            })
                        }
                    }
                } catch (e) {
                    console.error(e)
                }
            }

            this.props.addDescriptionItem(descriptionItem)
        })
    }

    render() {
        const { classes } = this.props

        const description = this.props.draft.description.map((item, index) => {
            const descriptionItem = {
                descriptionItemTypeId: TEXT,
                staticBlockId: null,
                bundleItemId: null,
                header: item.header,
                text: item.text,
                image1: -1,
                image2: -1,
                json: {
                    cols: [],
                    data: [],
                    boldedRows: [],
                    boldedCols: [],
                    boldedCells: [],
                },
                notForAllegro: false,
                notForMagento: false,
                notForHurton: false,
                youtubeLink: '',
                hoverIndex: null,
                headerIcon: '',
                filterStaticBlocks: false,
            }

            if (item.header.startsWith('Specyfikacja techniczna')) {
                descriptionItem.text = ''
                descriptionItem.descriptionItemTypeId = TABLE
                descriptionItem.json.cols = [
                    { name: 'A', key: 0 },
                    { name: 'B', key: 1 },
                ]

                try {
                    if (hasOwnProperty.call(item.text, 'data')) {
                        const data = item.text.data
                        descriptionItem.json.data = data

                        for (let i = 0, len = data.length; i < len; i++) {
                            descriptionItem.json.boldedCells.push({
                                row: i,
                                col: 0,
                            })
                        }
                    } else {
                        let data = JSON.parse(item.text)

                        if (hasOwnProperty.call(data, 'data')) {
                            data = data.data
                        }

                        descriptionItem.json.data = data

                        for (let i = 0, len = data.length; i < len; i++) {
                            descriptionItem.json.boldedCells.push({
                                row: i,
                                col: 0,
                            })
                        }
                    }
                } catch (e) {
                    console.error(e)
                }
            }

            return (
                <div className={classes.item} key={index}>
                    <ItemHeader classes={classes} header={item.header} />
                    {item.header.startsWith('Specyfikacja techniczna') ? (
                        <ItemTable classes={classes} data={item.text} />
                    ) : (
                        <ItemText classes={classes} text={item.text} />
                    )}

                    <div className="flex justify-end">
                        <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                this.props.addDescriptionItem(descriptionItem)
                            }
                        >
                            Dodaj blok do opisu
                        </Button>
                    </div>
                    <hr className={classNames(classes.hr, 'bg-grey-light')} />
                </div>
            )
        })

        return (
            <div>
                <div className="flex flex-row justify-between align-items-start">
                    <h3 className={classes.h}>Opis</h3>
                    <div>
                        <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            onClick={this.addAllBlocksToDescription}
                        >
                            Dodaj wszystkie bloki do opisu
                        </Button>
                        <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            onClick={this.toggleOpen}
                        >
                            Wygeneruj nowy opis
                        </Button>
                    </div>
                </div>
                {description}
                <GenerateDescriptionModal
                    open={this.state.open}
                    handleClose={this.toggleOpen}
                    onConfirm={this.props.generateProductDescription}
                    sku={this.props.sku}
                    productName={this.props.product.name}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        draft: state.presto.product.draft,
        product: state.presto.product.data.product,
    }
}

export default withStyles(styles)(
    connect(mapStateToProps, {
        getProductDraft,
        addDescriptionItem: addDescriptionItemWithNotification,
        generateProductDescription,
    })(ProductDraft)
)
